import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const style = StyleSheet.create({
  card: theme => ({
    marginBottom: 20,
    padding: 18,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    elevation: 2,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
    flex: 1,
    height: 130,
  }),

  myDevice: theme => ({
    fontSize: 16,
    marginVertical: 20,
    color: theme.colors.subtitle,
  }),
  deviceInfo: theme => ({
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorThree,
    paddingBottom: 10,
  }),
  deviceInfoTitle: theme => ({
    color: theme.colors.subtitle,
    fontSize: 15,
  }),
  deviceInfoSubTitle: {
    ...Fonts.type.bold,
    marginTop: 8,
    fontSize: 19,
  },
  deviceIcon: {
    marginRight: 15,
  },
  deviceCapacityContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 12,
  },
  deviceCapacityText: {
    fontSize: 17,
  },
  upperCase: {
    textTransform: 'uppercase',
  },
  hiddenDeviceIcon: {
    opacity: 0,
  },
});
export default style;
